export default __webpack_public_path__ + "static/media/visa_baijin.f7af4123.jpg";